import { render, staticRenderFns } from "./course.vue?vue&type=template&id=e6aa7d86&scoped=true&"
import script from "./course.vue?vue&type=script&setup=true&lang=js&"
export * from "./course.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=e6aa7d86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aa7d86",
  null
  
)

export default component.exports